/* ULTREIA — comportamiento
   1. Header de vidrio que se esconde al bajar
   2. Fade-up de secciones al entrar en viewport (una sola vez)
   3. Hero-carrusel: autoplay 5 s, deformación al correr,
      cursor-flecha por mitades, entrada escalonada          */

(function () {
  'use strict';

  /* 1 · Header */
  var last = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (y > last && y > 200) document.body.classList.add('u-nav-down');
    else document.body.classList.remove('u-nav-down');
    last = y;
  }, { passive: true });

  /* 2 · Fade-up, una sola vez por sección */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('u-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
  }

  function scanReveals() {
    if (!io) { document.querySelectorAll('.u-reveal').forEach(function (el) { el.classList.add('u-in'); }); return; }
    document.querySelectorAll('.u-reveal:not(.u-in)').forEach(function (el) { io.observe(el); });
  }

  /* 3 · Hero-carrusel */
  function heroInit(root) {
    var track = root.querySelector('.u-hero__track');
    var slides = [].slice.call(root.querySelectorAll('.u-hero__slide'));
    var dots = [].slice.call(root.querySelectorAll('.u-hero__dots button'));
    if (!track || !slides.length) return;

    var i = 0, timer = null;
    var DELAY = parseInt(root.getAttribute('data-autoplay') || '5000', 10);

    function paint() {
      track.style.transition = 'transform .9s cubic-bezier(.2,.7,.2,1)';
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }

    /* Deformación en los bordes: la portada se estira y se inclina
       al arrancar y vuelve sola durante el recorrido. */
    function deform(dir) {
      slides.forEach(function (s) {
        s.classList.remove('is-easing');
        s.style.transform = 'scaleX(1.04) skewX(' + (dir * -3) + 'deg)';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slides.forEach(function (s) {
            s.classList.add('is-easing');
            s.style.transform = '';
          });
        });
      });
    }

    function restart() {
      clearInterval(timer);
      if (slides.length > 1) timer = setInterval(function () { go(i + 1, 1); }, DELAY);
    }

    function go(n, dir) {
      var next = (n + slides.length) % slides.length;
      if (next === i) return;
      i = next;
      deform(dir || 1);
      paint();
      restart();
    }

    /* Cursor-flecha: izquierda retrocede, derecha avanza */
    track.addEventListener('mousemove', function (e) {
      var mid = root.getBoundingClientRect().left + root.offsetWidth / 2;
      var right = e.clientX > mid;
      track.classList.toggle('u-cur-r', right);
      track.classList.toggle('u-cur-l', !right);
    });

    track.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var mid = root.getBoundingClientRect().left + root.offsetWidth / 2;
      if (e.clientX > mid) go(i + 1, 1);
      else go(i - 1, -1);
    });

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(n, n > i ? 1 : -1); });
    });

    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    paint();
    restart();
  }

  function boot() {
    scanReveals();
    document.querySelectorAll('.u-hero').forEach(function (el) {
      if (el.getAttribute('data-booted')) return;
      el.setAttribute('data-booted', '1');
      heroInit(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();

/* Carrusel de libros: flechas + arrastre con el mouse.
   El riel ya scrollea solo con trackpad y dedo por el CSS; esto agrega lo que
      falta en desktop con mouse. Marcamos data-arrastre para no confundir un
         arrastre con un clic y abrir la ficha del libro sin querer. */
         (function () {
           function armarRiel(seccion) {
               var riel = seccion.querySelector('.product-grid');
                   if (!riel || riel.dataset.uRiel) return;
                       riel.dataset.uRiel = '1';

                           var caja = riel.parentElement;
                               caja.classList.add('u-riel');

                                   function flecha(dir, etiqueta, glifo) {
                                         var b = document.createElement('button');
                                               b.type = 'button';
                                                     b.className = 'u-flecha u-flecha--' + dir;
                                                           b.setAttribute('aria-label', etiqueta);
                                                                 b.textContent = glifo;
                                                                       b.addEventListener('click', function () {
                                                                               riel.scrollBy({ left: (dir === 'r' ? 1 : -1) * riel.clientWidth * 0.8, behavior: 'smooth' });
                                                                                     });
                                                                                           caja.appendChild(b);
                                                                                                 return b;
                                                                                                     }
                                                                                                         var izq = flecha('l', 'Libros anteriores', '‹');
                                                                                                             var der = flecha('r', 'Mas libros', '›');

                                                                                                                 function pintar() {
                                                                                                                       var max = riel.scrollWidth - riel.clientWidth - 2;
                                                                                                                             izq.hidden = riel.scrollLeft <= 2;
                                                                                                                                   der.hidden = riel.scrollLeft >= max;
                                                                                                                                       }
                                                                                                                                           riel.addEventListener('scroll', pintar, { passive: true });
                                                                                                                                               window.addEventListener('resize', pintar);
                                                                                                                                                   pintar();

                                                                                                                                                       var abajo = false, x0 = 0, s0 = 0, movido = 0;
                                                                                                                                                           riel.addEventListener('pointerdown', function (e) {
                                                                                                                                                                 if (e.pointerType !== 'mouse') return;
                                                                                                                                                                       abajo = true; movido = 0; x0 = e.clientX; s0 = riel.scrollLeft;
                                                                                                                                                                             riel.style.scrollBehavior = 'auto';
                                                                                                                                                                                   riel.style.cursor = 'grabbing';
                                                                                                                                                                                       });
                                                                                                                                                                                           window.addEventListener('pointermove', function (e) {
                                                                                                                                                                                                 if (!abajo) return;
                                                                                                                                                                                                       var d = e.clientX - x0;
                                                                                                                                                                                                             if (Math.abs(d) > 4) movido = 1;
                                                                                                                                                                                                                   riel.scrollLeft = s0 - d;
                                                                                                                                                                                                                       });
                                                                                                                                                                                                                           window.addEventListener('pointerup', function () {
                                                                                                                                                                                                                                 if (!abajo) return;
                                                                                                                                                                                                                                       abajo = false;
                                                                                                                                                                                                                                             riel.style.scrollBehavior = 'smooth';
                                                                                                                                                                                                                                                   riel.style.cursor = '';
                                                                                                                                                                                                                                                         if (movido) {
                                                                                                                                                                                                                                                                 riel.dataset.arrastre = '1';
                                                                                                                                                                                                                                                                         setTimeout(function () { delete riel.dataset.arrastre; }, 60);
                                                                                                                                                                                                                                                                               }
                                                                                                                                                                                                                                                                                   });
                                                                                                                                                                                                                                                                                       riel.addEventListener('click', function (e) {
                                                                                                                                                                                                                                                                                             if (riel.dataset.arrastre) { e.preventDefault(); e.stopPropagation(); }
                                                                                                                                                                                                                                                                                                 }, true);
                                                                                                                                                                                                                                                                                                   }

                                                                                                                                                                                                                                                                                                     function boot() {
                                                                                                                                                                                                                                                                                                         document.querySelectorAll('[id$="__libros"]').forEach(armarRiel);
                                                                                                                                                                                                                                                                                                           }
                                                                                                                                                                                                                                                                                                             if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
                                                                                                                                                                                                                                                                                                               else boot();
                                                                                                                                                                                                                                                                                                                 document.addEventListener('shopify:section:load', boot);
                                                                                                                                                                                                                                                                                                                 })();
                                                                                                                                                                                                                                                                                                                 

/* TALLERES: del boton al checkout, sin pasar por el carrito.
   Anotarse a un taller no es "comprar": no hay nada mas que sumar al pedido,
   asi que mandarlo al carrito es un paso de mas. Este bloque intercepta el
   submit SOLO en las fichas de taller (el <body> lleva la clase u-taller, que
   pone theme.liquid cuando product.type == 'Taller') y manda derecho al
   checkout. En libros no toca nada, porque ahi si tiene sentido sumar varios
   titulos antes de pagar.
   Ojo: se agrega por AJAX y recien despues se redirige. Si la llamada falla
   -sin señal, stock agotado- se deja seguir el envio normal del formulario,
   asi la persona igual termina en el carrito y no queda con un boton muerto. */
(function () {
  if (!document.body.classList.contains('u-taller')) return;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    // Craft trae su propio manejador en el formulario (product-form.js) que
    // TAMBIEN agrega al carrito. Sin esta linea corren los dos y el taller
    // entra duplicado: el cliente ve cantidad 2 y paga el doble. Por eso el
    // listener va en fase de captura (el 'true' del final) y corta la cadena
    // antes de que Craft llegue a ejecutar el suyo.
    e.stopImmediatePropagation();
    var boton = form.querySelector('[type="submit"]');
    if (boton) { boton.setAttribute('aria-disabled', 'true'); boton.classList.add('loading'); }

    // El taller va SOLO al checkout: primero se vacia el carrito y recien
    // despues se suma el taller. Sin esto, alguien que venia con libros a
    // medio comprar veia un total inesperado justo cuando queria anotarse,
    // que es exactamente la friccion que se quiso sacar.
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('no se pudo agregar'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        if (boton) { boton.removeAttribute('aria-disabled'); boton.classList.remove('loading'); }
        form.submit();
      });
  }, true);
})();
